import { ReactNode } from 'react'
import styled from '@emotion/styled'

type ConatinerPropsType = {
	children: ReactNode
}

const ProfileContainer = ({ children }: ConatinerPropsType) => {
	return <Container>{children}</Container>
}

const Container = styled.div`
	margin-top: 3.3rem;
`

export default ProfileContainer
